import { controls } from "../controls";

const ms421 = {
  label: "PACS Master",
  pageLabel: "PACS Master",
  starting: true,
  url: "pacsmaster",
  formActions: { edit: { allow: true } },
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Basic Info",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-1" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, star: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "PACS ID", width: "col-sm-1" }),
    ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "pacs_id", isRequired: true, star: true }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-1" }),
    ...controls.AccountNumber({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "account_number_display", name: "account_number_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "PACS CIN", width: "col-sm-1" }),
    ...controls.customerNumber({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),


    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-1" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Village", width: "col-sm-1" }),
    ...controls.Village({
      tab: "filter"
    }),
    ...controls.showData({ tab: "filter", data: "village_display", name: "village_display", width: "col-sm-2" }),
  ],
  form: [
    {
      widths: "col-sm-12",
      tab: "create",
      title: "PACS Details",
      subComponents: [
        ...controls.displayText({ tab: "create", label: "Parent Branch", width: "col-sm-1" }),
        ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, star: true, defaultValue: "assigned_branch" }),
        ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

        ...controls.displayText({ tab: "create", label: "PACS ID", width: "col-sm-1" }),
        ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "pacs_id", isRequired: true, star: true }),
        ...controls.displayText({ tab: "create", width: "col-sm-4" }),

        // ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-1" }),
        // ...controls.AccountNumber({ tab: "create" }),
        // ...controls.showData({ tab: "create", data: "account_number_display", name: "account_number_display", width: "col-sm-2" }),

        ...controls.displayText({ tab: "create", label: "PACS CIN", width: "col-sm-1" }),
        ...controls.customerNumber({ tab: "create" }),
        ...controls.showData({ tab: "create", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),

        ...controls.displayText({ tab: "create", label: "PACS Name", width: "col-sm-1" }),
        ...controls.text({ tab: 'create', isReadOnly: 'edit', name: "pacs_name", width: "col-sm-6", isRequired: true, star: true }),
      ],
    },
    {
      widths: "col-sm-12",
      tab: "create",
      title: "Area of Operation",
      subComponents: [
        ...controls.displayText({ tab: "Modal", label: "Taluka", width: "col-sm-1" }),
        ...controls.Taluka({ tab: "Modal" }),
        ...controls.showData({ tab: "Modal", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

        ...controls.displayText({ tab: "Modal", label: "Village", width: "col-sm-1" }),
        ...controls.Village({
          tab: "Modal", parents: [
            {
              name: "taluka_display",
              match: "exist",
              show: 'readonly'
            }
          ]
        }),
        ...controls.showData({ tab: "Modal", data: "village_display", name: "village_display", width: "col-sm-2" }),

        ...controls.button({
          label: "ADD", onclick: {
            action: "appendToHTMLTable",
            tableNameField: 'area_of_operation_table',
            requiredField: ["Village", "village_display", "Taluka", "taluka_display"]
          }, width: "col-sm-1"
        }),
        {
          inputType: "table",
          tableTitle: "",
          // convertedTo: "nominee_table",
          deletable: true,
          // editable: true,
          // addRows: true,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Village Code", field: "Village" },
            { label: "Village", field: "village_display" },
            { label: "Taluka Code", field: "Taluka" },
            { label: "Taluka", field: "taluka_display" }
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "area_of_operation_table"
        }
      ]
    },

    {
      widths: "col-sm-12",
      tab: "create",
      title: "Crop Linkage",
      subComponents: [
        ...controls.displayText({ tab: "create", label: "Crop", width: "col-sm-1" }),
        ...controls.text({ tab: "filter", name: "crop", width: "col-sm-2", placeHolder: "" }),

        ...controls.displayText({ tab: "create", label: "Area In", width: "col-sm-1" }),
        ...controls.select({
          tab: "Modal", name: "area_in", width: "col-sm-1", placeHolder: "Area", defaultValue: "",
          options: [{
            label: "Hectare",
            value: "hectare"
          },
          {
            label: "Acre",
            value: "acre"
          }]
        }),

        ...controls.displayText({ tab: "create", label: "Non Irrigated", width: "col-sm-1" }),
        ...controls.numberOnly({ tab: "create", name: "non_irrigated_area", width: "col-sm-1", placeHolder: "Area" }),

        ...controls.displayText({ tab: "create", label: "Irrigated", width: "col-sm-1" }),
        ...controls.numberOnly({ tab: "create", name: "irrigated_area", width: "col-sm-1", placeHolder: "Area" }),

        ...controls.button({
          label: "ADD", style: { padding: 0 },
          Bcolor: "success", onclick: {
            action: "appendToHTMLTable",
            tableNameField: 'crop_linkage_table',
            requiredField: ["crop", "crop_name_display", "area_in", "irrigated_area", "non_irrigated_area"]
          }, width: "col-sm-1"
        }),
        {
          inputType: "table",
          tableTitle: "",
          // convertedTo: "nominee_table",
          deletable: true,
          // editable: true,
          // addRows: true,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Code", field: "crop" },
            { label: "Name", field: "crop_name_display" },
            { label: "Area In", field: "area_in" },
            { label: "Irrigated", field: "irrigated" },
            { label: "Non Irrigated", field: "non_irrigated" }
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "crop_linkage_table"
        }
      ]
    },
  ],
  history: {
    perPage: 10,
    reportHeader: "PACS Master",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_display",
        width: 150, type: "small"
      },
      {
        Header: "PACS ID",
        accessor: "pacs_id",
      },
      {
        Header: "Taluka",
        accessor: "taluka_display",
      },
      {
        Header: "Village",
        accessor: "village_display",
      },
    ]
  }
};

export default ms421;